import React from 'react';
import { Badge } from '../ui/Badge';
import { cn } from '../../utils/cn';
import type { GateItemStatus, RecordStatus, Track } from '../../types/domain';
import { trackLabel } from '../../utils/stages';
const recordStatusMap: Record<RecordStatus, {
  label: string;
  className: string;
}> = {
  'in-review': {
    label: 'In review',
    className: 'bg-muted text-foreground border-border'
  },
  'info-requested': {
    label: 'Info requested',
    className: 'bg-uae-gold/12 text-uae-bronze border-uae-gold/40'
  },
  active: {
    label: 'Active',
    className: 'bg-uae-leaf/10 text-uae-leaf border-uae-leaf/30'
  },
  rejected: {
    label: 'Declined',
    className: 'bg-uae-red/10 text-uae-red border-uae-red/30'
  },
  closed: {
    label: 'Closed',
    className: 'bg-muted text-muted-foreground border-border'
  }
};
export function RecordStatusPill({
  status
}: {
  status: RecordStatus;
}) {
  const config = recordStatusMap[status];
  return <span className={cn('inline-flex items-center rounded-sm border px-1.5 py-0.5 text-[11px]', config.className)} data-id="element-578" data-mp="2r2hxw7h8mp1p">
      {config.label}
    </span>;
}
const trackClasses: Record<Track, string> = {
  mega: 'bg-uae-green text-white border-uae-green',
  major: 'bg-uae-navy/10 text-uae-navy border-uae-navy/30',
  international: 'bg-uae-gold/12 text-uae-bronze border-uae-gold/40'
};
export function TrackPill({
  track
}: {
  track: Track;
}) {
  return <span className={cn('inline-flex items-center rounded-sm border px-1.5 py-0.5 text-[11px]', trackClasses[track])} data-id="element-579" data-mp="21qq7n3trgleh">
      {trackLabel(track).replace(' Event', '')}
    </span>;
}
const gateStatusMap: Record<GateItemStatus, {
  label: string;
  className: string;
}> = {
  met: {
    label: 'Met',
    className: 'bg-uae-leaf/10 text-uae-leaf border-uae-leaf/30'
  },
  partial: {
    label: 'Partial',
    className: 'bg-uae-gold/12 text-uae-bronze border-uae-gold/40'
  },
  outstanding: {
    label: 'Outstanding',
    className: 'bg-uae-red/10 text-uae-red border-uae-red/30'
  }
};
export function GateStatusPill({
  status
}: {
  status: GateItemStatus;
}) {
  const config = gateStatusMap[status];
  return <span className={cn('inline-flex items-center rounded-sm border px-1.5 py-0.5 text-[11px]', config.className)} data-id="element-580" data-mp="2uesvizh5hdux">
      {config.label}
    </span>;
}
export function SeverityPill({
  severity
}: {
  severity: 'critical' | 'high' | 'medium';
}) {
  const className = severity === 'critical' ? 'bg-uae-red text-white border-uae-red' : severity === 'high' ? 'bg-uae-red/10 text-uae-red border-uae-red/30' : 'bg-uae-gold/12 text-uae-bronze border-uae-gold/40';
  return <span className={cn('inline-flex items-center rounded-sm border px-1.5 py-0.5 text-[10px] uppercase tracking-wide', className)} data-id="element-581" data-mp="26m2pt7zubqt3">
      {severity}
    </span>;
}
export function DocumentStatusBadge({
  status
}: {
  status: 'missing' | 'uploaded' | 'verified' | 'rejected';
}) {
  if (status === 'verified') return <Badge variant="outline" className="border-uae-leaf/30 bg-uae-leaf/10 text-uae-leaf" data-id="element-582" data-mp="85abiwm41lzg">
        Verified
      </Badge>;
  if (status === 'uploaded') return <Badge variant="outline" className="border-border bg-muted text-foreground" data-id="element-583" data-mp="i4sub9qab1px">
        Uploaded
      </Badge>;
  if (status === 'rejected') return <Badge variant="outline" className="border-uae-red/30 bg-uae-red/10 text-uae-red" data-id="element-584" data-mp="m5bk6y8m9xph">
        Rejected
      </Badge>;
  return <Badge variant="outline" className="border-uae-gold/40 bg-uae-gold/12 text-uae-bronze" data-id="element-585" data-mp="3qk312v54cv41">
      Missing
    </Badge>;
}